var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35,
    stroke: "#84DCC8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6666 36C52.6666 45.2047 45.2047 52.6666 35.9999 52.6666C26.7952 52.6666 19.3333 45.2047 19.3333 36C19.3333 26.7952 26.7952 19.3333 35.9999 19.3333C45.2047 19.3333 52.6666 26.7952 52.6666 36Z",
    fill: "#84DCC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7173 30.9494C43.2055 31.4376 43.2055 32.229 42.7173 32.7172L34.384 41.0505C33.8958 41.5387 33.1044 41.5387 32.6162 41.0505L29.2829 37.7172C28.7947 37.229 28.7947 36.4376 29.2829 35.9494C29.771 35.4613 30.5625 35.4613 31.0506 35.9494L33.5001 38.3989L37.2248 34.6742L40.9495 30.9494C41.4377 30.4613 42.2291 30.4613 42.7173 30.9494Z",
    fill: "#1177BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp);
export default __webpack_public_path__ + "static/media/sign_up.093f9bf9909c05059a89c235b87023dc.svg";
export { ForwardRef as ReactComponent };